<template>
	<div class="form-signup">
		<b-form @submit.prevent="submit">
			<b-form-group
				label="Name"
				label-for="name"
				description="Change your username"
			>
				<b-form-input
					id="name"
					v-model="form.name"
					type="text"
					required
					placeholder="Lady Gaga"
				></b-form-input>
			</b-form-group>
			<b-form-group
				label="Readwise API key"
				label-for="setpassword-password"
				description="Add a Readwise API key and bulk export your notes straight to Readwise"
			>
				<b-form-input
					id="setpassword-password"
					v-model="form.readwise"
					type="text"
					placeholder="********"
				></b-form-input>
				<small class="text-warning" v-if="$v.form.readwise.$error">
					Please make sure your API key is correct
				</small>
			</b-form-group>
			<b-button
				type="submit"
				variant="primary"
				:class="[{ disabled: lock === true }]"
				>Update account settings<b-spinner
					:class="['ml-1']"
					small
					v-if="lock"
				></b-spinner
			></b-button>
			<div class="form-error" v-if="errorMessage">
				{{ errorMessage }}
			</div>
			<br />
			<br />
		</b-form>
	</div>
</template>

<script>
import { required, minLength, between } from 'vuelidate/lib/validators';
import emailValidator from '@/lib/email-validator.js';
export default {
	data: function () {
		return {
			lock: false,
			errorMessage: '',
			form: {
				name: '',
				password: '',
				readwise: '',
			},
		};
	},
	validations: {
		form: {
			name: {
				required,
			},
			readwise: {},
		},
	},
	methods: {
		reset: function () {
			// this.form = {
			// };
		},
		submit: function () {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				//this.lock = true;
				this.$store
					.dispatch('user/updateSettings', this.form)
					.then((res) => {
						if (res.status === 201) {
							this.reset();
							this.$store.dispatch('user/refreshToken');
							this.$store.dispatch('message/onUpdateSettings');
						}
						this.lock = false;
					})
					.catch((err) => {
						this.errorMessage = `Something went wrong, please try again`;
					});
			}
		},
	},
	created: function () {
		if (this.$store.getters['user/hasReadwise']) {
			this.form.readwise = this.$store.getters['user/hasReadwise'];
		}
		this.form.name = this.$store.getters['user/user'].name;
	},
};
</script>

<style lang="scss">
.form-signup {
	.custom-radio {
		background-color: rgba(0, 0, 0, 0.15);
		padding: 0.5rem;
		padding-left: 36px;
		border-radius: 8px;
		margin-bottom: 1rem;
	}
	.custom-control-label {
		width: 100%;
		h4 {
			margin-bottom: 0.2rem;
		}
		&:before {
			left: -26px;
		}
		&:after {
			left: -26px;
		}
		p {
			margin: 0;
		}
	}
}
</style>
